import Litepicker from 'litepicker/dist/nocss/litepicker.umd.js';
import 'litepicker/dist/plugins/mobilefriendly';

export default {
  create(element) {
    const picker = new Litepicker({
      delimiter: '-',
      format: 'YYYY/MM/DD',
      element: element[0],
      lang: $('html').attr('lang'),
      dropdowns: {
        months: true,
        years: true,
      },
      numberOfMonths: 2,
      numberOfColumns: 2,
      singleMode: false,
      plugins: ['mobilefriendly'],
      showTooltip: false,
    });

    picker.on('render', () => {
      // Fix days.
      const days = $('.container__days div');
      days.each((_i, day) => {
        day = $(day);
        day.html('<span>' + day.text() + '</span>');
      });

      // Fix weekdays.
      const weekdayContainers = $('.month-item-weekdays-row');
      weekdayContainers.each((i, weekdayContainer) => {
        const weekdays = $(weekdayContainer).children('div');
        weekdays.each((i, weekday) => {
          weekday = $(weekday);
          let text;
          if (i < 6) {
            text = weekday.text().substring(0, 1);
          }
          if (i == 6) {
            text = weekday.text().substring(0, 2);
          }
          weekday.text(text);
        });
      });
    });

    // Close litepicker on click outside.
    $('.litepicker-backdrop').on('click', (e) => {
      e.preventDefault();
      picker.hide();
    });

    return picker;
  },
};
